const PSYCHIATRY = 'psychiatry'
const MATCH_PROFESSIONAL_SHOWCASE = 'MATCH_PROFESSIONAL_SHOWCASE'
const ALLOW_PROFESSIONAL_CANCELLATION = 'ALLOW_PROFESSIONAL_CANCELLATION'

export const featureName = {
  PSYCHIATRY,
  MATCH_PROFESSIONAL_SHOWCASE,
  ALLOW_PROFESSIONAL_CANCELLATION,
}
